import { Component, OnInit, Input, ViewChild } from '@angular/core';
import { NgbActiveModal } from '@ng-bootstrap/ng-bootstrap';
import { Subject } from 'rxjs';
import { DataTableDirective } from 'angular-datatables';
import { SpinnerService } from 'src/app/services/spinner.service';
import { setConfigTable, setConfigTableModalBusqueda } from 'src/app/shared/utils';

@Component({
  selector: 'app-modal-busqueda-articulos',
  templateUrl: './modal-tab-especificaciones.component.html',
  styleUrls: ['./modal-tab-especificaciones.component.css']
})
export class ModalArticuloEspecificacionComponent implements OnInit {

  @Input() clasesSelectEspecificaciones: [];

  dtTrigger: Subject<null> = new Subject();
  dtOptions: any = {};

  @ViewChild(DataTableDirective) dtElement: DataTableDirective;
  constructor(private modalService: NgbActiveModal, 
    private spinnerService: SpinnerService) { };

  ngOnInit(): void {
    console.log(this.clasesSelectEspecificaciones)
    this.dtOptions = setConfigTableModalBusqueda(false);
    setTimeout(() => {
      this.dtTrigger.next();  
   
      this.spinnerService.activarLoading(false);
    }, 500);
  }

  onClick(data: any): void {
    this.modalService.close(data);
  }

  cancelar(): void {
    this.modalService.dismiss('canceling');
  }
}
